/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDisputes = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h15v4h5v16h-3.535l-2-3H7v-3.197L5.535 18H2zm7 13v2h8.535l2 3H20V8h-3v7zm6-2V4H4v12h.465l2-3zM8.5 9V5h2v4zm0 3v-2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDisputes as Disputes };
